const QR_EXPORT_SIZE = 560;
const QR_QUIET_ZONE = 20;

async function inlineSvgLogo(svgEl) {
  const imageEl = svgEl.querySelector("image");
  if (!imageEl) return;

  const href = imageEl.getAttribute("href");
  if (!href || href.startsWith("data:")) return;

  try {
    const res = await fetch(href);
    const blob = await res.blob();
    const dataUri = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
    imageEl.setAttribute("href", dataUri);
  } catch {
    // proceed without inlining logo
  }
}

export async function getQrCanvasFromElement(containerEl) {
  const svgEl = containerEl?.querySelector?.("svg");
  if (!svgEl) {
    throw new Error("svg not found");
  }

  const clonedSvg = svgEl.cloneNode(true);
  const origW =
    parseFloat(svgEl.getAttribute("width")) ||
    svgEl.getBoundingClientRect().width ||
    220;
  const origH =
    parseFloat(svgEl.getAttribute("height")) ||
    svgEl.getBoundingClientRect().height ||
    220;

  if (!clonedSvg.getAttribute("viewBox")) {
    clonedSvg.setAttribute("viewBox", `0 0 ${origW} ${origH}`);
  }

  const canvasSize = QR_EXPORT_SIZE + QR_QUIET_ZONE * 2;
  clonedSvg.setAttribute("width", String(QR_EXPORT_SIZE));
  clonedSvg.setAttribute("height", String(QR_EXPORT_SIZE));

  await inlineSvgLogo(clonedSvg);

  const svgData = new XMLSerializer().serializeToString(clonedSvg);
  const svgBlob = new Blob([svgData], {
    type: "image/svg+xml;charset=utf-8",
  });
  const url = URL.createObjectURL(svgBlob);

  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = canvasSize;
      canvas.height = canvasSize;
      const ctx = canvas.getContext("2d");
      ctx.imageSmoothingEnabled = false;
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvasSize, canvasSize);
      ctx.drawImage(img, QR_QUIET_ZONE, QR_QUIET_ZONE, QR_EXPORT_SIZE, QR_EXPORT_SIZE);
      URL.revokeObjectURL(url);
      resolve(canvas);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Failed to load QR image"));
    };
    img.src = url;
  });
}

export async function copyCanvasAsPng(canvas) {
  const blob = await new Promise((resolve, reject) => {
    canvas.toBlob((result) => {
      if (result) resolve(result);
      else reject(new Error("Failed to create image blob"));
    }, "image/png");
  });

  await navigator.clipboard.write([
    new ClipboardItem({ "image/png": blob }),
  ]);
}

export function downloadCanvasAsPng(canvas, filename = "Rupin QR Code") {
  const link = document.createElement("a");
  link.href = canvas.toDataURL("image/png");
  link.download = `${filename}.png`;
  link.click();
}
